import React from 'react';
import Grid from '@mui/material/Grid';

const GridItem = ({ children, ...rest }) => {
  return (
    <Grid item {...rest}>
      {children}
    </Grid>
  );
};

export default GridItem;
